import './App.css';
import Home from './components/Home/Home';
import { Routes, Route } from "react-router-dom";
import Navbar from './components/Navbar/Navbar';
import Shop from './components/Shop/Shop';

function App() {
  return (
    <div>
      {/* <Header></Header> */}
      <Navbar>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/shop" element={<Shop/>} />

        </Routes>
      </Navbar>
     
    </div>
  );
}

export default App;
